import React from "react";
import { Box, Typography } from "@mui/material";

interface StyledProgressBarProps {
    value: number; // Progress value from 0 to 100
    labelText: string;
}
  
const StyledProgressBar: React.FC<StyledProgressBarProps> = ({
value,
labelText,
}) => {
return (
    <Box sx={{ p: 4, textAlign: "center" }}>
    {/* Text Label */}
    <Typography
        sx={{
        color: "#555555",
        textAlign: "center",
        marginBottom: "10px",
        fontSize: "0.875rem",
        }}
    >
        {labelText}
    </Typography>

    {/* Progress Bar Container */}
    <Box
        sx={{
        position: "relative",
        height: "25px",
        borderRadius: "12.5px",
        border: "3px solid #F2C2CE",
        background: `
            linear-gradient(to bottom, transparent, rgba(0,0,0,0.25) 50%, transparent), /* Darker center */
            repeating-linear-gradient(70deg, #ccd0f0ff, #ccd0f0ff 7px, #d7dbffff 7px, #d7dbffff 14px) /* Stripes */
        `, // Darker stripes
        boxShadow: "inset 0px 1px 3px rgba(0, 0, 0, 0.1)",
        overflow: "hidden",
        }}
    >
        {/* Progress Bar Fill */}
        <Box
        sx={{
            height: "100%",
            width: `${value}%`,
            borderRadius: "10.0px", // Adjusted for new padding
            // Layered background for highlights + base color
            background: `
            radial-gradient(circle 8px at 5px center, rgba(255, 255, 255, 0.6) 0%, rgba(255, 255, 255, 0) 100%),
            radial-gradient(circle 8px at calc(100% - 5px) center, rgba(255, 255, 255, 0.6) 0%, rgba(255, 255, 255, 0) 100%),
            linear-gradient(to bottom, #F9B3C1, #e63e5fff 50%, #F9B3C1)
            `,
            boxShadow: `inset 0px 4px 4px rgba(255, 255, 255, 0.7), 
                        inset 0px -2px 4px rgba(0, 0, 0, 0.1), 
                        5px 0px 8px rgba(0, 0, 0, 0.3)`, // More pronounced drop shadow on the right
            transition: "width .4s ease",
        }}
        />

        {/* Overlay for the "gray border" gap effect */}
        <Box
        sx={{
            position: "absolute",
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            borderRadius: "12.5px", // Match container's border radius
            border: "1px solid #F5F5F5", // This border creates the gray gap (smaller)
            boxSizing: "border-box", // Ensures border is inside
            pointerEvents: "none", // Allow clicks to pass through
        }}
        />
    </Box>
    </Box>
);
};

export default StyledProgressBar;